import { Component, Inject } from '@angular/core';
import { PolicyService } from '../../core/services/policy.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent {

  policy = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: {appName: string}, private policyService: PolicyService) {
   
    if(this.data?.appName != 'AssessmentApp'){
      policyService.getTermsAndConditions().subscribe(val => {
        this.policy = val;
      });
    }
    else{
      policyService.getAssessmentAppTermsAndConditions().subscribe(val => {
        this.policy = val;
      }); 
    }
  }
}
